import React, { useEffect, useState, useMemo } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import "./WeeklyMatchups.css";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../config";
import getSearchParam from "../../../../../../../hooks/UrlSearchParam";
import { COLORS } from '../../../../../../../Util/helper';
import SortableList, { SortableItem } from "react-easy-sort";
import _ from 'lodash';
import { toast } from "react-toast";
import { messages } from '../../../../../../../messages';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import WarningDialogue from '../../../../../../../Util/WarningDialogue';

function WeeklyMatchups(props) {
  const history = useHistory();
  const [leagueId, setLeagueId] = useState(0);
  const [matches, setMatches] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [division, setDivision] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const confirmSchedule = props.confirmSchedule || false;
  const reSchedule = props.reSchedule || false;
  const search = useLocation().search;
  const teamMatches = useMemo(() => {
    const counts = {};
    if (matches && matches.length > 0) {
      matches.forEach((item) => {
        item?.schedule?.forEach((match) => {
          if (match.team1_id > 0 && match.team2_id > 0) {
            counts[match.team1_id] = (counts[match.team1_id] || 0) + 1;
          }
        });
      });
    }
    return counts;
  }, [matches]);
  const season_id = new URLSearchParams(search).get('season_id');

  useEffect(() => {
    const leagueId_ = getSearchParam(props.location).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      getWeeklyMatchup();
    }
    //eslint-disable-next-line
  }, [leagueId]);

  useEffect(() => {
    if (confirmSchedule) {
      confirmWeeklySchedule();
    }
    //eslint-disable-next-line
  }, [confirmSchedule]);

  useEffect(() => {
    if (reSchedule) {
      getWeeklyMatchup();
    }
    //eslint-disable-next-line
  }, [reSchedule]);

  const getWeeklyMatchup = () => {
    axiosApi.get(`${config.apiUrl}/leagues/schedule/weekly/matchup/${leagueId}/${reSchedule}`)
      .then((response) => {
        setErrorMessage(response.data.message);
        if (response.data.status === 'success') {
          if (response.data && response.data.teamData) {
            response.data.teamData = response.data.teamData.map((v, i) => ({ ...v, color: COLORS[i] }))
          }
          setTeamData(response.data.teamData);
          setMatches(response.data.data ? response.data.data : []);
          setDivision(response.data.divisionData ? response.data.divisionData : []);
        }
        if (response.data.conflicts) {
          setOpenWarningPopup(true);
          setPopUpContent({
            header: 'Warning',
            description: messages.conflictedFields,
            icon: faExclamationCircle,
            action: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/weekly-match`,
                  search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}&selected=true` : ''}`,
                })
              }, 100);
            }
          });
        }
        if (reSchedule) {
          props.emit(true);
        }
      }).catch(err => {
        if (reSchedule) {
          props.emit(true);
        }
      })
  }

  const confirmWeeklySchedule = async () => {
    if (matches.length) {
      const schedule = _.uniqBy([].concat.apply([], matches.map(x => x.schedule)), 'original_id').map(obj => ({ id: obj.original_id, team1_id: obj.team1_id, team2_id: obj.team2_id })).filter(s => s.id);
      try {
        axiosApi.post(`${config.apiUrl}/leagues/schedule/weekly/confirm`, { schedule })
      } finally {
        props.emit(true);
      }
    }
  }

  const teamName = (id) => {
    let name = 'N/A';
    if (id && teamData) {
      const findTeam = teamData.find(x => +x.id === +id);
      if (findTeam) {
        name = `${findTeam.name} (${findTeam.preferred_time.charAt(0).toUpperCase()})`;
      }
    }
    return name;
  }

  const colorCode = (id) => {
    let color = '';
    if (id && teamData) {
      color = teamData.find(x => +x.id === +id) ? teamData.find(x => +x.id === +id).color : '';
    }
    return color;
  }

  const checkConflicts = (id1, id2) => {
    let conflict = '';
    if (id1 && id2 && teamData) {
      let preferredTime1 = teamData.find(x => +x.id === +id1) ? teamData.find(x => +x.id === +id1).preferred_time : '';
      let preferredTime2 = teamData.find(x => +x.id === +id2) ? teamData.find(x => +x.id === +id2).preferred_time : '';
      if (preferredTime1 && preferredTime2) {
        preferredTime1 = preferredTime1.charAt(0).toUpperCase();
        preferredTime2 = preferredTime2.charAt(0).toUpperCase();
        if (preferredTime1 !== 'B' && preferredTime2 !== 'B') {
          if (preferredTime1 !== preferredTime2) {
            conflict = <sup style={{ color: 'red', fontSize: 'medium' }}>*</sup>;
          }
        }
      }
    }
    return conflict;
  }

  const onSortEnd = (oldIndex, newIndex) => {
    const sourceIndex = Math.floor(oldIndex / teamData.length);
    const destIndex = Math.floor(newIndex / teamData.length);
    const items = [...matches];
    if (sourceIndex === destIndex) {
      if (matches[sourceIndex] && matches[destIndex]) {
        if (sourceIndex > 0) {
          oldIndex = Math.ceil(oldIndex % teamData.length);
        }
        if (destIndex > 0) {
          newIndex = Math.ceil(newIndex % teamData.length);
        }
        const oldTeamId = matches[sourceIndex].schedule && matches[sourceIndex].schedule[oldIndex] ? matches[sourceIndex].schedule[oldIndex].team2_id : null;
        const newTeamId = matches[destIndex].schedule && matches[destIndex].schedule[newIndex] ? matches[destIndex].schedule[newIndex].team2_id : null;
        const teamDivision = division.map(d => JSON.parse('[' + d.team_ids + ']'));
        let executeNext = true;
        if (teamDivision && teamDivision.length) {
          if (!teamDivision.filter(tm => tm.includes(oldTeamId) && tm.includes(newTeamId)).length) {
            executeNext = false;
            toast.hideAll();
            toast.error(messages.different_division_error);
          }
        }
        if (executeNext) {
          let teamOrder = [...matches[sourceIndex].schedule];
          if (oldTeamId && newTeamId) {
            teamOrder.forEach(element => {
              let cTeam1Id = element.team1_id;
              let cTeam2Id = element.team2_id;
              switch (element.team1_id) {
                case oldTeamId:
                  cTeam1Id = newTeamId;
                  break;
                case newTeamId:
                  cTeam1Id = oldTeamId;
                  break;
                default:
                  break;
              }
              switch (element.team2_id) {
                case oldTeamId:
                  cTeam2Id = newTeamId;
                  break;
                case newTeamId:
                  cTeam2Id = oldTeamId;
                  break;
                default:
                  break;
              }
              element.team1_id = cTeam1Id;
              element.team2_id = cTeam2Id;
            });
            teamOrder = _.sortBy(teamOrder, ['team1_id']);
            items[sourceIndex].schedule = [...teamOrder];
            setMatches(items);
          } else {
            if (oldTeamId || newTeamId) {
              if (oldTeamId) {
                const newUpdatedTeamId = teamOrder[newIndex].team1_id;
                teamOrder[newIndex].team2_id = oldTeamId;
                const findIndex = teamOrder.findIndex(to => +to.team1_id === +oldTeamId);
                if (findIndex !== -1) {
                  teamOrder[findIndex].team2_id = newUpdatedTeamId;
                }
              }
              if (newTeamId) {
                const newUpdatedTeamId = teamOrder[oldIndex].team1_id;
                teamOrder[oldIndex].team2_id = newTeamId;
                const findIndex = teamOrder.findIndex(to => +to.team1_id === +newTeamId);
                if (findIndex !== -1) {
                  teamOrder[findIndex].team2_id = newUpdatedTeamId;
                }
              }
              teamOrder[!newTeamId ? oldIndex : newIndex].team2_id = !newTeamId ? newTeamId : oldTeamId;
              teamOrder = _.sortBy(teamOrder, ['team1_id']);
              items[sourceIndex].schedule = [...teamOrder];
              setMatches(items);
            }
          }
        }
      }
    }
  };



  
  return (
    <>
      {
        matches.length > 0 &&
        teamData.length > 0 &&
        <div className="weekly-matchup schedule-create-block">
          <h2>Weekly Matchups</h2>
          <p>Drag and drop team horizontally to change match</p>
          <div className="create-schedule-innner">
            <div className="schedule-create-row headingblock max-width-content">
              <div className="schedule-create-col col1 first"></div>
              {
                teamData.map((val, index) => (
                  <div className={`schedule-create-col col${index + 2}`} key={'column-weekly-matchup-' + val.id}>
                    <span style={{ background: val.color }}></span>
                    {`${val.name} (${val.preferred_time.charAt(0).toUpperCase()})`}
                  </div>
                )
                )
              }
            </div>
            <SortableList onSortEnd={onSortEnd} draggedItemClassName="draggableWeekly">
              {
                matches.map((matchup, index) => (
                  <div className={`schedule-create-row row${index + 1}`} key={`weekly-matchup-row-${matchup?.week_day}`}>
                    <div className="schedule-create-col col1" >
                      {matchup?.week_day}
                      <br />
                      {matchup.date}
                    </div>
                    {
                      matchup?.schedule &&
                      matchup.schedule.map((order, index_) => (
                        <SortableItem key={index_}>
                          <div className={`schedule-create-col col${index_ + 2}`}>
                            <span style={{ background: colorCode(order.team2_id) }}></span>
                            {teamName(order.team2_id)}
                            {checkConflicts(order?.team1_id, order?.team2_id)}
                          </div>
                        </SortableItem>
                      ))
                    }
                  </div>
                ))
              }
            </SortableList>
            <div className="schedule-create-row">
               <div className="schedule-create-col col1" >
                  Total
                  <br />
                  Matches
                </div>
                {
                 teamData && teamMatches && teamData.length > 0 && teamData.map((team, team_index) => (
                    <div className={`schedule-create-col col${team_index + 2}`} key={`total-matches-${team.id}`}>
                      {teamMatches[team.id] || 0}
                    </div>
                  ))
                }
            </div>
            {
              division &&
              division.length > 0 &&
              <div className="division-info">
                {
                  division.map((dv, i) => (
                    <div className="division-inner" key={`division-${i}`}>
                      <h3>{dv.name}</h3>
                      <ul>
                        {
                          dv.team_ids &&
                          dv.team_ids.split(',').map((team, index) => (
                            <li key={`${team}-${index}`}>{teamName(team)}</li>
                          ))
                        }
                      </ul>
                    </div>
                  ))
                }
              </div>
            }
          </div>
        </div>
      }
      {
        errorMessage &&
        errorMessage !== '' &&
        <div className="weekly-matchup schedule-create-block">
          <div className="no-record">
            <h3>
              {errorMessage}
            </h3>
          </div>
        </div>
      }
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => { setOpenWarningPopup(false); }}
      />
    </>
  );
}

export default withRouter(WeeklyMatchups);
